import { createValidator } from "@gpp-ui/validator";
const validator = createValidator({
  useRegex: false,
  useSchema: true,
  useUtils: false
});
const { useSchema } = validator;
export const requiredPhoneNumberSchema = useSchema().getSchema("requiredPhoneNumberSchema");
export const optionalPhoneNumberSchema = useSchema().getSchema("optionalPhoneNumberSchema");
